import {Component, ElementRef, forwardRef, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {AbstractValueAccessorComponent} from '../../../../../common/component/value-accessor.component';
import {BerthVisit, RegisterAtdUsingId, RemoveAtd} from '@portbase/bezoekschip-service-typescriptmodels/common';
import {VisitContext} from '../../../../visit-context';
import {AppContext} from '../../../../../app-context';
import {checkValidity, scrollToTop, sendCommand} from '../../../../../common/utils';

@Component({
    selector: 'app-register-atd',
    templateUrl: './register-atd.component.html',
    styleUrls: ['./register-atd.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RegisterAtdComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegisterAtdComponent extends AbstractValueAccessorComponent<BerthVisit> implements OnInit {
  context = VisitContext;
  @Input() berthVisit: BerthVisit;
  atd: string;
  modalOpen: boolean;

  @Input() id;

  constructor(private elementRef: ElementRef) {
    super();
  }

  get value(): BerthVisit {
    return this.berthVisit;
  }

  writeValue(value: BerthVisit): void {
    this.berthVisit = value;
  }

  ngOnInit(): void {
    if (!this.id) {
      throw new Error('Attribute "id" is required for register-atd-component');
    }
  }

  isAtdModifiable = () => {
    return VisitContext.isAtaAtdModifiable();
  };

  withModal = (action: "toggle" | "show" | "hide" | "handleUpdate" | "dispose") => {
    this.modalOpen = action === 'show';
    $('#' + this.id + 'registerAtdModal').modal(action);
  };

  registerAtd() {
    const result = checkValidity(this.elementRef);
    if (!result) {
      return;
    }
    sendCommand('com.portbase.bezoekschip.common.api.visit.RegisterAtdUsingId', <RegisterAtdUsingId> {
      crn: this.context.visit.crn,
      berthVisitId: this.berthVisit.id,
      atd: this.atd
    }, () => {
      this.berthVisit.atd = this.atd;
      this.context.replaceVisit(this.context.visit);
      AppContext.registerSuccess('ATD registered successfully.');
    });
    scrollToTop();
    this.withModal('hide');
  }

  removeAtd() {
    sendCommand('com.portbase.bezoekschip.common.api.visit.RemoveAtd', <RemoveAtd> {
      crn: this.context.visit.crn,
      berthVisitId: this.berthVisit.id
    }, () => {
      this.berthVisit.atd = null;
      this.context.replaceVisit(this.context.visit);
      AppContext.registerSuccess('ATD successfully removed.');
    });
    scrollToTop();
    this.withModal('hide');
  }
}
